var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5C14.1562 13.5 13.5 14.1875 13.5 15C13.5 15.8438 14.1562 16.5 15 16.5C15.8125 16.5 16.5 15.8438 16.5 15C16.5 14.1875 15.8125 13.5 15 13.5ZM13.5 10.25C13.5 11.0938 14.1562 11.75 15 11.75C15.8125 11.75 16.5 11.0938 16.5 10.25C16.5 9.4375 15.8125 8.75 15 8.75C14.1562 8.75 13.5 9.4375 13.5 10.25ZM13.5 19.75C13.5 20.5938 14.1562 21.25 15 21.25C15.8125 21.25 16.5 20.5938 16.5 19.75C16.5 18.9375 15.8125 18.25 15 18.25C14.1562 18.25 13.5 18.9375 13.5 19.75Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsWhite);
export default __webpack_public_path__ + "static/media/dots-white.b3dd3cb6.svg";
export { ForwardRef as ReactComponent };